export default __webpack_public_path__ + "static/sentinelOne-cee44ef0570fdfa9b452f5a3b017348b.png";